export function formatIsoDateDe(iso) {
  if (!iso) return '';
  const [y, m, d] = String(iso).slice(0, 10).split('-');
  if (!y || !m || !d) return String(iso);
  return `${d}.${m}.${y}`;
}

/** Rückschau-Zeilen: Ursprung → Ziel und offener Nachholtermin. */
export function relocationLines(entry) {
  if (!entry) return [];
  const lines = [];
  if (entry.relocated_from_date) {
    lines.push(`Verlegt vom ${formatIsoDateDe(entry.relocated_from_date)}`);
  }
  if (entry.relocated_to_date) {
    lines.push(`Verlegt auf ${formatIsoDateDe(entry.relocated_to_date)}`);
  } else if (entry.makeup_open) {
    lines.push('Noch nachzuholen');
  }
  return lines;
}

export function lessonStatusSuffix(entry) {
  if (!entry) return '';
  if (entry.relocated_to_date) return ' · VERLEGT';
  if (entry.makeup_open) return ' · OFFEN';
  if (entry.cancelled) return ' · AUSFALL';
  return '';
}
